<!-- 护理人员配置 -->
<template>
	<div class="main" style="width: 1180px;">
		<a-card>
			<a-tabs v-model="key" @change="callback">
				<a-tab-pane key="1" tab="护理人员配置">
					<nursingDeploy></nursingDeploy>
				</a-tab-pane>
				<a-tab-pane key="2" tab="院长&管理员配置">
					<deanAdminDeploy></deanAdminDeploy>
				</a-tab-pane>
				<!-- 需求隐藏 - 致真客户 -->
				<!-- <a-tab-pane key="3" tab="异常处理配置">
          <inspectionDeploy></inspectionDeploy>
        </a-tab-pane> -->
			</a-tabs>
		</a-card>
	</div>
</template>

<script>
import nursingDeploy from './nursingDeploy';
import deanAdminDeploy from './deanAdminDeploy';
import inspectionDeploy from './InspectionDeploy';
export default {
	components: {
		nursingDeploy,
		deanAdminDeploy,
		inspectionDeploy,
	},
	data() {
		return {
			key: '1' || localStorage.getItem('key1'),
		};
	},
	created() { },
	mounted() {
		this.key = localStorage.getItem('key1')
			? localStorage.getItem('key1')
			: '1';
	},
	methods: {
		// 监听切换
		callback(e) {
			localStorage.setItem('key1', e);
		},
	},
};
</script>
<style lang="scss" scoped>
.main::v-deep {
	padding: 20px 0;

	.ant-card {
		padding: 15px 20px;
		border-radius: 8px;

		.ant-card-body {
			padding: 0;
		}
	}

	.ant-tabs-bar {
		border-bottom: none;
	}
}</style>
